import { useEffect, useRef } from 'react'

/** Default dismiss time for Tally alerts / toast-style messages. */
export const TALLY_ALERT_MS = 3500

/** Clear `value` after `ms` whenever it becomes truthy. */
export function useAutoDismiss(
  value: string | null | undefined,
  clear: () => void,
  ms: number = TALLY_ALERT_MS,
): void {
  const clearRef = useRef(clear)
  clearRef.current = clear

  useEffect(() => {
    if (!value) return
    const id = window.setTimeout(() => clearRef.current(), ms)
    return () => window.clearTimeout(id)
  }, [value, ms])
}
